import without from 'lodash/without';

export const SET_CHART_VIEW_SETTINGS = 'SET_CHART_VIEW_SETTINGS';
export const SET_CHART_SETTINGS = 'SET_CHART_SETTINGS';
export const SET_CHART_BREAKDOWN = 'SET_CHART_BREAKDOWN';
export const SET_CHART_METRICS = 'SET_CHART_METRICS';
export const SET_CHART_WIDTH = 'SET_CHART_WIDTH';
export const SHOW_CHART_ANNOTATIONS = 'SHOW_CHART_ANNOTATIONS';
export const HIDE_CHART_ANNOTATIONS = 'HIDE_CHART_ANNOTATIONS';
export const CHART_ACTIVATE_BREAKDOWN_MODE = 'CHART_ACTIVATE_BREAKDOWN_MODE';
export const CHART_DEACTIVATE_BREAKDOWN_MODE =
  'CHART_DEACTIVATE_BREAKDOWN_MODE';

export const CHANGE_CART_LOADING_TYPE = 'CHANGE_CART_LOADING_TYPE';

const getMetricMixedTypes = (
  currentMixedTypes,
  { nextMetricIds = [], prevMetricIds = [] }
) => {
  const addedIds = without(nextMetricIds, ...prevMetricIds);
  const removedIds = without(prevMetricIds, ...nextMetricIds);
  const mixedTypes = [
    ...currentMixedTypes.filter(({ id }) => !removedIds.includes(id)),
    ...addedIds.map((id) => ({ id, type: 'line', label: false })),
  ];

  return mixedTypes;
};

const getBreakdownMixedTypes = (
  currentMixedTypes,
  { nextTopItemsCount, prevTopItemsCount = 0 }
) => {
  if (nextTopItemsCount === prevTopItemsCount) {
    return currentMixedTypes;
  }

  return nextTopItemsCount > prevTopItemsCount
    ? [
        ...currentMixedTypes.slice(0, prevTopItemsCount),
        ...Array(nextTopItemsCount - prevTopItemsCount).fill({ type: 'line' }),
      ]
    : currentMixedTypes.slice(0, nextTopItemsCount);
};

export function chartReducer(state = {}, action) {
  switch (action.type) {
    case CHANGE_CART_LOADING_TYPE: {
      return {
        ...state,
        lazy: action.payload,
      };
    }
    case SET_CHART_WIDTH:
      return {
        ...state,
        width: action.payload,
      };

    case SHOW_CHART_ANNOTATIONS:
      return {
        ...state,
        annotations: {
          ...action.payload,
          showAnnotations: true,
        },
      };

    case HIDE_CHART_ANNOTATIONS:
      return {
        ...state,
        annotations: {
          ...state.annotations,
          showAnnotations: false,
        },
      };

    case SET_CHART_SETTINGS:
      return {
        ...state,
        settings: action.payload,
      };

    case SET_CHART_VIEW_SETTINGS:
      return {
        ...state,
        chartViewSettings: action.payload,
      };

    case SET_CHART_METRICS:
      return {
        ...state,
        metrics: action.payload,
        chartViewSettings: {
          ...state.chartViewSettings,
          metricMixedTypes: getMetricMixedTypes(
            state.chartViewSettings.metricMixedTypes,
            {
              nextMetricIds: action.payload,
              prevMetricIds: state.metrics,
            }
          ),
        },
      };

    case CHART_ACTIVATE_BREAKDOWN_MODE: {
      let breakdown = state.breakdown;
      let chartViewSettings = state.chartViewSettings;

      if (!breakdown.topItemsCount) {
        // empty
        const metrics = state.metrics;
        const breakdownMetric =
          metrics && metrics.length === 1 ? metrics[0] : '';

        breakdown = {
          breakdownMetric: breakdownMetric,
          topItemsCount: 3,
        };

        chartViewSettings = {
          ...chartViewSettings,
          breakdownMixedTypes: getBreakdownMixedTypes([], {
            nextTopItemsCount: 3,
          }),
        };
      }

      return {
        ...state,
        breakdownMode: true,
        breakdown: breakdown,
        chartViewSettings: chartViewSettings,
      };
    }

    case CHART_DEACTIVATE_BREAKDOWN_MODE: {
      let chartViewSettings = state.chartViewSettings;
      const chartType = chartViewSettings.type;

      chartViewSettings = {
        ...chartViewSettings,
        breakdownMixedTypes: [],
        percentage: false,
        stacked: false,
      };

      if (chartType === 'pie') {
        chartViewSettings = {
          ...chartViewSettings,
          type: 'line',
        };
      }

      return {
        ...state,
        breakdownMode: false,
        breakdown: {},
        chartViewSettings: chartViewSettings,
      };
    }

    case SET_CHART_BREAKDOWN:
      let chartViewSettings = state.chartViewSettings;
      const metricChanged =
        action.payload.breakdownMetric !== state.breakdown.breakdownMetric;

      return {
        ...state,
        breakdown: action.payload,
        chartViewSettings: {
          ...chartViewSettings,
          breakdownMixedTypes: getBreakdownMixedTypes(
            chartViewSettings.breakdownMixedTypes,
            {
              nextTopItemsCount: action.payload.topItemsCount,
              prevTopItemsCount: metricChanged
                ? 0
                : state.breakdown.topItemsCount,
            }
          ),
        },
      };
    default:
      return state;
  }
}
